import { Stack, styled } from "@mui/material";
import {
  LgTextSemiBold,
  Product,
  ProductSkeleton,
  Row,
  Swiper,
  ViewAllText,
} from "Components";
import { AUTO_PLAY_ITEM_TIME, COLORS } from "constants/layout";
import { PATHS } from "constants/routes";
import useGetData from "hooks/useGetData";
import { memo, useMemo } from "react";
import { useIntl } from "react-intl";
import { apiGetNewArrivals } from "services/api/listing";
import { SwiperSlide } from "swiper/react";
import { ProductType } from "types";

type Props = {};

const BREAKPOINTS = {
  300: {
    slidesPerView: 2,
    spaceBetween: 8,
  },
  1048: {
    slidesPerView: 3,
    spaceBetween: 8,
  },
};

const NewArrivals = (props: Props) => {
  const t = useIntl();
  const { data, isLoading } = useGetData({
    promise: () => apiGetNewArrivals({ limit: 6 }),
    deps: [],
  });
  const products: ProductType[] = useMemo(() => data?.data || [], [data]);

  return (
    <StyledStack spacing={1} className="card">
      <Row justifyContent="space-between">
        <LgTextSemiBold className="title" color={COLORS.gray[800]}>
          {t.formatMessage({ id: "new_product_from_verified_suppliers" })}
        </LgTextSemiBold>
        <ViewAllText to={PATHS.newArrivals} />
      </Row>

      {products.length > 0 && (
        <Swiper
          pagination={undefined}
          autoplay={{ delay: AUTO_PLAY_ITEM_TIME, disableOnInteraction: false }}
          breakpoints={BREAKPOINTS}
        >
          {isLoading &&
            Array.from(new Array(3)).map((_, index) => (
              <SwiperSlide key={index}>
                <ProductSkeleton />
              </SwiperSlide>
            ))}
          {products.map((product: any, i: number) => (
            <SwiperSlide key={i}>
              <Product {...{ product }} />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </StyledStack>
  );
};

const StyledStack = styled(Stack)(({ theme }) => ({
  ".title": {
    span: {
      color: COLORS.error[500],
    },
  },

  [theme.breakpoints.down("md")]: {
    padding: 8,
  },
}));

export default memo(NewArrivals);
